import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Welcome({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3.5 -2.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M9.8672 19.4918l-4.654-6.9526667-1.644-2.45599997c-.27-.40333333-.36666667-.88666666-.27266667-1.362C3.3912 8.2458 3.66453333 7.8358 4.0672 7.5658c.83133333-.55666667 1.96066667-.33333333 2.51733333.498l6.29799997 9.4093333" />
        <path d="M18.4538 13.7438l-6.298-9.40866667c-.27-.40333333-.3666667-.88666666-.272-1.362.094-.47533333.3673333-.88533333.77-1.15533333.832-.55666667 1.9613333-.33333333 2.518.498l10.814 16.1546667c.1406667.2433333.4106667.4006666.7106667.3826666.2246666-.0126666.4206666-.1226666.552-.2853333.0006666-.0013333.002-.0026667.0033333-.004.0126667-.016.0253333-.0326667.0366667-.0506667.004-.0053333.0073333-.01.0106666-.0153333.0086667-.0146667.0173334-.028.0253334-.0433333.0046666-.008.0093333-.0173334.014-.0266667.0053333-.0106667.0113333-.0226667.016-.034.006-.0133333.0113333-.0253333.016-.0386667.0033333-.0086666.006-.0166666.0086666-.0253333.006-.0166667.0113334-.0346667.016-.052.0013334-.0046667.002-.0093333.0033334-.0133333.0206666-.0866667.0273333-.1753334.0173333-.2646667l-.3106667-6.192c.0273334-.7386667.4086667-1.42266667 1.0246667-1.83466667.3966667-.266.8593333-.39933333 1.3386667-.38733333 1.272.032 2.2806666 1.092 2.2493333 2.3646667-.0006667.0106666-.0006667.0226666 0 .0333333l.2006667 10.746c-.1006667 3.8026667-2.046 7.3333333-5.206 9.4486667l-.302.202c-5.3813334 3.602-12.6906667 2.1546666-16.2926667-3.2273334l-9.198-13.74c-.26933333-.4026666-.366-.886-.272-1.3613333.094-.476.368-.886.77066667-1.1553333C2.2498 12.3398 3.37913333 12.5631333 3.9358 13.3951333l4.654 6.9513334" />
        <path d="M14.1604667 16.6174667L7.86246667 7.2088 6.21713333 4.75146667c-.26866666-.402-.36533333-.886-.272-1.36266667.094-.47466667.368-.88466667.77066667-1.154.832-.55666667 1.96066667-.33266667 2.51733333.49866667L17.1758 14.5994667" />
      </g>
    </svg>
  )
}

Welcome.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
